// @ts-strict-ignore
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-warning',
    templateUrl: './app-warning.component.html',
    styleUrls: ['./app-warning.component.scss'],
    standalone: false
})
export class AppWarningComponent implements OnInit {
  @Input() title: string;
  @Input() isStrongWarning = false;

  constructor() {}

  ngOnInit() {}
}
